import BackgroundImagesRender from "Components/Paralax/BackgroundImagesRender";
import ParalaxElement from "Components/Paralax/ParalaxElement";
import { t } from "i18next";
import { Fragment, useMemo, useState } from "react";
function importAll(r) {
  return r.keys().map(r);
}
export default function ParalaxList() {
  const pack0 = useMemo(
    () =>
      importAll(
        require.context("../../assets/img/samples", false, /\.(png|jpe?g|svg)$/)
      ).slice(24),
    []
  );
  const pack1 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/1",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack2 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/2",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack3 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/3",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack4 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/4",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack5 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/5",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack6 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/6",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack7 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/7",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack8 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/8",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack9 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/9",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack10 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/10",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const pack11 = useMemo(
    () =>
      importAll(
        require.context(
          "../../assets/img/history-of-mikolajow/11",
          false,
          /\.(png|jpe?g|svg)$/
        )
      ).slice(3),
    []
  );
  const imagesArr = useMemo(
    () => [
      pack0,
      pack1,
      pack2,
      pack3,
      pack4,
      pack5,
      pack6,
      pack7,
      pack8,
      pack9,
      pack10,
      pack11,
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const useHover = () => {
    const [hovered, setHovered] = useState();
    const eventHandlers = useMemo(
      () => ({
        onMouseOver(e) {
          setHovered(e.target.id);
          setImages(imagesArr[e.target.id]);
        },
        onMouseOut(e) {
          setHovered(0);
          setImages(imagesArr[0]);
        },
      }),
      []
    );

    return [hovered, eventHandlers];
  };
  const [hovered, eventHandlers] = useHover(0);
  const [images, setImages] = useState(imagesArr[0]);
  return (
    <Fragment>
      <div className="paralax__list d-flex flex-column justify-content-center align-items-center z-index-11 pt-5">
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={1}
          title={t("The Story of Mikołajów")}
          content={
            <Fragment>
              <p>{t("TheStoryOfMikołajów1")}</p>
              <p>{t("TheStoryOfMikołajów2")}</p>
            </Fragment>
          }
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={2}
          title={t("18thCenturyTitle")}
          content={t("18thCenturyContent")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={3}
          title={t("1944Title")}
          content={t("1944Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={4}
          title={t("1960sTitle")}
          content={t("1960sContent")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={5}
          title={t("1970sTitle")}
          content={t("1970sContent")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={6}
          title={t("1986Title")}
          content={t("1986Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={7}
          title={t("1992Title")}
          content={t("1992Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={8}
          title={t("1995Title")}
          content={t("1995Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={9}
          title={t("2010Title")}
          content={t("2010Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={10}
          title={t("2022Title")}
          content={t("2022Content")}
        />
        <ParalaxElement
          ev={{ hovered, eventHandlers }}
          id={11}
          title={t("TheFutureTitle")}
          content={t("TheFutureContent")}
        />
      </div>
      <BackgroundImagesRender images={images} layer={1} />
    </Fragment>
  );
}
